import { Directive, HostListener } from '@angular/core';

// goab-details' host click handler (used to sync open/closed state) fires for any click that
// bubbles up, including clicks on its own projected content. Add this to the projected content
// wrapper so interacting with it (buttons, links, text) doesn't also toggle the details closed.
@Directive({
  selector: '[stopDetailsContentClick]',
  standalone: true,
})
export class StopDetailsContentClickDirective {
  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.stopPropagation();
  }
}
